/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_PaymentInputs */

const en_admin_settings_tabs_payment = /** @type {(inputs: Admin_Settings_Tabs_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const zh_admin_settings_tabs_payment = /** @type {(inputs: Admin_Settings_Tabs_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Admin_Settings_Tabs_PaymentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_payment = /** @type {((inputs?: Admin_Settings_Tabs_PaymentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_PaymentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_payment(inputs)
	return zh_admin_settings_tabs_payment(inputs)
});
export { admin_settings_tabs_payment as "admin.settings.tabs.payment" }